var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34.5,
    viewBox: "0 0 36 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_1_",
    "data-name": "security (1)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M21,31a.752.752,0,0,1-.291-.058C20.352,30.79,12,27.181,12,19.8V13.536a.751.751,0,0,1,.51-.711l8.25-2.786a.751.751,0,0,1,.48,0l8.25,2.786a.749.749,0,0,1,.51.711V19.8c0,7.377-8.352,10.986-8.709,11.137A.752.752,0,0,1,21,31ZM13.5,14.076V19.8c0,5.676,6.083,8.937,7.5,9.62,1.416-.684,7.5-3.958,7.5-9.62V14.076L21,11.542Z",
    transform: "translate(6 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M18.75,21.25a.352.352,0,0,1-.041,0,.744.744,0,0,1-.545-.281l-3-3.75a.75.75,0,1,1,1.172-.937l2.475,3.095,4.658-4.656a.75.75,0,0,1,1.061,1.06l-5.25,5.25a.747.747,0,0,1-.53.221Z",
    transform: "translate(7.5 6.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M27.75,11.5H5.25A5.25,5.25,0,0,1,5.25,1h22.5a5.25,5.25,0,0,1,0,10.5Zm-22.5-9a3.75,3.75,0,0,0,0,7.5h22.5a3.75,3.75,0,0,0,0-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M5.25,7.5A2.25,2.25,0,1,1,7.5,5.25,2.253,2.253,0,0,1,5.25,7.5Zm0-3A.75.75,0,1,0,6,5.25.752.752,0,0,0,5.25,4.5Z",
    transform: "translate(1.5 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M10.25,7.5A2.25,2.25,0,1,1,12.5,5.25,2.253,2.253,0,0,1,10.25,7.5Zm0-3a.75.75,0,1,0,.75.75A.752.752,0,0,0,10.25,4.5Z",
    transform: "translate(4 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M14.25,17.5h-9A5.25,5.25,0,0,1,5.25,7h22.5a5.143,5.143,0,0,1,3.192,1.089.75.75,0,0,1-.923,1.183A3.653,3.653,0,0,0,27.75,8.5H5.25a3.75,3.75,0,0,0,0,7.5h9a.75.75,0,0,1,0,1.5Z",
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M5.25,13.5A2.25,2.25,0,1,1,7.5,11.25,2.253,2.253,0,0,1,5.25,13.5Zm0-3a.75.75,0,1,0,.75.75A.752.752,0,0,0,5.25,10.5Z",
    transform: "translate(1.5 4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M10.25,13.5a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,10.25,13.5Zm0-3a.75.75,0,1,0,.75.75A.752.752,0,0,0,10.25,10.5Z",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M14.25,23.5h-9a5.25,5.25,0,0,1,0-10.5h9a.75.75,0,0,1,0,1.5h-9a3.75,3.75,0,0,0,0,7.5h9a.75.75,0,0,1,0,1.5Z",
    transform: "translate(0 6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M5.25,19.5A2.25,2.25,0,1,1,7.5,17.25,2.253,2.253,0,0,1,5.25,19.5Zm0-3a.75.75,0,1,0,.75.75A.752.752,0,0,0,5.25,16.5Z",
    transform: "translate(1.5 7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M10.25,19.5a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,10.25,19.5Zm0-3a.75.75,0,1,0,.75.75A.752.752,0,0,0,10.25,16.5Z",
    transform: "translate(4 7)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e80eaf15fa7287b7cd6af9a6a3212bd1.svg";
export { ForwardRef as ReactComponent };